export const rentPaymentFieldConfiguration = [
  {
    name: "rentId",
    label: "Rent",
    type: "combo",
    dataKey: "rents",
    validation: { required: "Rent is required" },
  },
  {
    name: "paymentDate",
    label: "Payment Date",
    type: "date",
    validation: { required: "Payment date is required" },
  },
  {
    name: "paymentAmount",
    label: "Payment Amount",
    type: "number",
    validation: { required: "Payment amount is required" },
  },
  {
    name: "paymentMethod",
    label: "Payment Method",
    type: "select",
    options: [
      { value: "Statements", label: "Statements" },
      { value: "ACH", label: "ACH" },
      { value: "Zelle", label: "Zelle" },
      { value: "Cash", label: "Cash" },
      { value: "Cashier Check", label: "Cashier Check" },
      { value: "Money Order", label: "Money Order" },
      { value: "QuickBook Payment", label: "QuickBook Payment" },
    ],
    validation: { required: "Payment method is required" },
  },
];

export const rentPaymentInitialValues = {
  rentId: "",
  paymentDate: "",
  paymentAmount: 0,
  paymentMethod: "",
  createdBy: "",
};
